export const BOOK_DEMO_URL =
  'https://calendly.com/reviewlumen/30-minute-meeting';

export const SANDBOX_PADDLE_PRICING_URLS = {
  starter: {
    monthly: 'https://sandbox-pay.paddle.io/hsc_01ks5q99rbddzvrb4xe813mshj_59x69mh1cwfz84f2pcdzgavkdnej2yp1',
    annually: 'https://sandbox-pay.paddle.io/hsc_01ks5tzs3m0ht3yngk1mbjpm0d_brd4gz6w2zc404dd5freq3ejjm4dc7pj',
  },
  growth: {
    monthly: 'https://sandbox-pay.paddle.io/hsc_01ks5vfyzn7zj8bwfsf5ejerkr_fzm6v4d3rzdc1gjmw1yaaazy05dsb05n',
    annually: 'https://sandbox-pay.paddle.io/hsc_01ks5vhd1m07kh4pf7q8fptb9j_agp31j5g458fnjrzpqq0n7m0q7vc2f6v',
  },
  pro: {
    monthly: 'https://sandbox-pay.paddle.io/hsc_01ks5vhxv8n0ns986fce6p4js7_gdb9f3570w8p0k7rb42kpp3bt4kak93a',
    annually: 'https://sandbox-pay.paddle.io/hsc_01ks5vk5kkxx7xhyz2kr8ng8gy_j1d3c1bb22qgvc93f07ea4k36qqmxyqh'
  },
};

export const PADDLE_PRICING_IDS = {
  starter: {
    monthly: 'pri_01ks3tpnj4v11f6p3pjzzxtgbj',
    annually: 'pri_01ks5a6ksb5sqz31njk0fdezvc',
  },
  growth: {
    monthly: 'pri_01ks5aepy4320rh1txmjs7m1bd',
    annually: 'pri_01ks5ahjt8vdnscnysp5n0n0k0',
  },
  pro: {
    monthly: 'pri_01ks5ak0v5a11epx7xrjs7p9f0',
    annually: 'pri_01ks5aksv4k86nq9fpewy4w6xt'
  },
};